import { Button, Checkbox, Container, FormControl, FormErrorMessage, FormLabel, Input, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Select } from "@chakra-ui/react";
import { Field, Form, Formik } from "formik";
import { FC, useEffect, useState } from "react";
import BankAccountService from "../../services/bankaccounts/bankaccount-service";
import OrderService from "../../services/orders/order-service";
import LogosNotification from "../../utils/notification-utils";

interface OrderPayManualDialogProps {
    order: any
    onClose: any,
    onRefreshData: any
};

const formInitialValue = {
    bankName: '',
    accountName: '',
    accountNumber: '',
    logosBankAccountId: '',
    amount: '',
    isFullPayment: false,
    screenshot: null
};

const OrderPayManualDialog: FC<OrderPayManualDialogProps> = ({ order, onClose, onRefreshData }) => {
    const [formValue, setFormValue] = useState<any>(formInitialValue);
    const [isSubmiting, setIsSubmiting] = useState<boolean>(false);
    const [bankAccounts, setBankAccounts] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        setIsLoading(true);
        BankAccountService.GetActiveBankAccounts().then((res: any) => {
            setBankAccounts(res.result);
        }).finally(() => {
            setIsLoading(false);
        });
    }, []);

    const handleFormSubmit = (values: any) => {
        setIsSubmiting(true);
        OrderService.PayManual(order.id, values.logosBankAccountId, values.accountName, values.amount, values.isFullPayment, values.screenshot).then((res: any) => {
            onRefreshData(res.result);
        }).finally(() => {
            setIsSubmiting(false);
        })
    };

    const formValidation = (values: any) => {
        //if (values.screenshot == null)
        //    return { screenshot: 'Silahkan upload bukti transfer' };
    };

    return (
        <Modal isOpen={true} onClose={onClose} >
            <ModalOverlay />
            <ModalContent>
                {
                    isLoading && "Loading..."
                }
                {
                    !isLoading &&
                    <Formik initialValues={formValue} onSubmit={handleFormSubmit} validate={formValidation}>
                        {
                            ({ handleSubmit, errors, touched, setFieldValue }) => (
                                <Form onSubmit={handleSubmit} noValidate={true}>
                                    <ModalHeader textAlign={"center"}>Pembayaran {order.invoiceNo}</ModalHeader>
                                    <ModalBody pt={5}>

                                        {/*<FormControl isRequired isInvalid={!!(errors.bankName && touched.bankName)}>*/}
                                        {/*    <FormLabel htmlFor='bankName'>Nama Bank</FormLabel>*/}
                                        {/*    <Field*/}
                                        {/*        as={Input}*/}
                                        {/*        id='bankName'*/}
                                        {/*        placeholder='Nama Bank'*/}
                                        {/*        name={'bankName'}*/}
                                        {/*        validate={(value: any) => {*/}
                                        {/*            let error;*/}
                                        {/*            if (value.length <= 0)*/}
                                        {/*                error = "Nama Bank wajib diisi.";*/}
                                        {/*            return error;*/}
                                        {/*        }}*/}
                                        {/*    />*/}
                                        {/*    <FormErrorMessage>{errors.bankName}</FormErrorMessage>*/}
                                        {/*</FormControl>*/}

                                        {/*<FormControl isRequired isInvalid={!!(errors.accountNumber && touched.accountNumber)} mt={4}>*/}
                                        {/*    <FormLabel htmlFor='accountNumber'>Nomor Rekening</FormLabel>*/}
                                        {/*    <Field*/}
                                        {/*        as={Input}*/}
                                        {/*        id='accountNumber'*/}
                                        {/*        placeholder='Nomor Rekening'*/}
                                        {/*        name={'accountNumber'}*/}
                                        {/*        validate={(value: any) => {*/}
                                        {/*            let error;*/}
                                        {/*            if (value.length <= 0)*/}
                                        {/*                error = "Nomor Rekening wajib diisi.";*/}
                                        {/*            return error;*/}
                                        {/*        }}*/}
                                        {/*    />*/}
                                        {/*    <FormErrorMessage>{errors.accountNumber}</FormErrorMessage>*/}
                                        {/*</FormControl>*/}

                                        <FormControl isRequired isInvalid={!!(errors.accountName && touched.accountName)} mt={4}>
                                            <FormLabel htmlFor='accountNumber'>Nama Pengirim</FormLabel>
                                            <Field
                                                as={Input}
                                                id='accountName'
                                                placeholder='Nama Rekening'
                                                name={'accountName'}
                                                validate={(value: any) => {
                                                    let error;
                                                    if (value.length <= 0)
                                                        error = "Nama Rekening wajib diisi.";
                                                    return error;
                                                }}
                                            />
                                            <FormErrorMessage>{errors.accountName}</FormErrorMessage>
                                        </FormControl>

                                        <FormControl isRequired mt={4}>
                                            <FormLabel htmlFor='logosBankAccountId'>Tujuan Rekening</FormLabel>
                                            <Field
                                                as={Select}
                                                id='logosBankAccountId'
                                                placeholder='Pilih Akun Bank'
                                                name={'logosBankAccountId'}
                                                validate={(value: any) => {
                                                    let error;
                                                    if (!value)
                                                        error = "Silahkan pilih Akun Bank";
                                                    return error;
                                                }}
                                            >
                                                {
                                                    bankAccounts.map((bankAccount: any) => {
                                                        return <option value={bankAccount.id}>{`${bankAccount.bankName} - ${bankAccount.bankAccountName}`}</option>
                                                    })
                                                }
                                            </Field>
                                            <FormErrorMessage>{errors.logosBankAccountId}</FormErrorMessage>
                                        </FormControl>

                                        <FormControl isRequired isInvalid={!!(errors.amount && touched.amount)} mt={4}>
                                            <FormLabel htmlFor='amount'>Total yang dibayar</FormLabel>
                                            <Field
                                                as={Input}
                                                type={'number'}
                                                min={0}
                                                id='amount'
                                                placeholder='Total yang dibayar'
                                                name={'amount'}
                                                validate={(value: any) => {
                                                    let error;
                                                    if (value < 0)
                                                        error = "Total yang dibayar wajib diisi.";
                                                    else if (value > order.outstanding)
                                                        error = `Total yang dibayar tidak boleh lebih besar dari ${String.toFormatSeparator(order.outstanding)}.`;
                                                    return error;
                                                }}
                                            />
                                            <FormErrorMessage>{errors.amount}</FormErrorMessage>
                                        </FormControl>

                                        <FormControl isRequired mt={4}>
                                            <Field
                                                as={Checkbox}
                                                id='isFullPayment'
                                                name={'isFullPayment'}
                                            >
                                                Sudah Lunas?
                                            </Field>
                                        </FormControl>

                                        <FormControl isInvalid={!!(errors.screenshot && touched.screenshot)} mt={4}>
                                            <FormLabel htmlFor='screenshot'>Bukti Transfer</FormLabel>
                                            <input
                                                type={'file'}
                                                id='screenshot'
                                                name={'screenshot'}
                                                accept="image/*"
                                                onChange={(event: any) => {
                                                    setFieldValue("screenshot", event.currentTarget.files[0]);
                                                }}
                                            />
                                            <FormErrorMessage>{errors.screenshot}</FormErrorMessage>
                                        </FormControl>

                                    </ModalBody>
                                    <ModalFooter>
                                        <Button variant={'outline'} mr={3} onClick={onClose}>
                                            Close
                                        </Button>
                                        <Button type={'submit'} isLoading={isSubmiting}>Bayar Sekarang</Button>
                                    </ModalFooter>
                                </Form>
                            )
                        }
                    </Formik>
                }
            </ModalContent>
        </Modal>
    );
};

export default OrderPayManualDialog;
